import { FrameworkConfiguration } from 'aurelia-framework';
import { DocsModule } from 'app/docs/module';

export function configure(config: FrameworkConfiguration) {
    config.singleton(DocsModule.registrationKey, DocsModule);
    config.globalResources([
        'app/docs/elements/live-example',
        'app/docs/elements/prism-code'
    ])
}
